import { LogOut } from "lucide-react";
import { useEffect } from "react";
import api from "@/lib/api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/Logo";

export default function StaffLayout({ children }) {
  const { user, logout } = useAuth();
  const nav0 = useNavigate();
  useEffect(() => {
    if (!user || ["admin", "manager"].includes(user.role)) return;
    api.get("/attendance/today").then((r) => { if (r.data.required && !r.data.marked) nav0("/selfie", { replace: true }); }).catch(() => {});
  }, [user, nav0]);
  const loc = useLocation();
  const nav = useNavigate();
  const tabs = [
    { path: "/dashboard", label: "Shift" },
    { path: "/my-shifts", label: "My Shifts" },
  ];
  return (
    <div className="min-h-screen bg-slate-50 pattern-dots">
      <header className="sticky top-0 z-30 bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-4 h-16">
          <button
            onClick={() => nav("/dashboard")}
            className="flex items-center gap-2 group"
            data-testid="brand-btn"
          >
            <BrandMark />
          </button>
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex flex-col items-end mr-2">
              <span className="text-sm font-medium">{user?.name}</span>
              <span className="text-[11px] text-slate-500">{user?.employee_id}</span>
            </div>
            {["admin", "manager"].includes(user?.role) && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => nav("/admin")}
                data-testid="go-admin-btn"
                className="rounded-full"
              >
                Admin
              </Button>
            )}
            <Button
              size="icon"
              variant="ghost"
              onClick={logout}
              data-testid="logout-btn"
              aria-label="Logout"
            >
              <LogOut className="w-5 h-5" />
            </Button>
          </div>
        </div>
        <nav className="max-w-3xl mx-auto flex px-4 gap-1 border-t border-slate-100">
          {tabs.map((t) => (
            <Link
              key={t.path}
              to={t.path}
              data-testid={`nav-${t.label.toLowerCase().replace(" ", "-")}`}
              className={`px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                loc.pathname === t.path
                  ? "border-[color:var(--bpcl-blue)] text-[color:var(--bpcl-blue)]"
                  : "border-transparent text-slate-500 hover:text-slate-900"
              }`}
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6 pb-24">{children}</main>
    </div>
  );
}
